import Model from './model';
import JSONReader from 'utils/reader';
import User from './user';

export default class Album extends Model {
  static fields = [
    { name: 'id', defaultValue: 0 },
    { name: 'slug', defaultValue: '' },
    'type',
    { name: 'title', defaultValue: '' },
    { name: 'songs', defaultValue: [] },
    { name: 'author', mapping: (raw) => JSONReader({ model: User }, raw.author), defaultValue: {} },
    { name: 'genres', defaultValue: [] },
    { name: 'published', defaultValue: false },
    { name: 'isFavorite', defaultValue: false },
    'image',
    'description',
    'copyright',
    'phonographic',
    'released',
    'time',
  ];
}